import { map, addIndex, clone } from 'ramda';

export const ixMap = addIndex(map);

// shuffle teams
// https://stackoverflow.com/questions/6274339/how-can-i-shuffle-an-array
export const shuffle = (arr) => {
  var a = clone(arr);

  for (let i = a.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [a[i], a[j]] = [a[j], a[i]];
  }
  return a;
};

// hmStr e.g. 09:00
export const timeStringToSeconds = (hmStr) => {
  if (!hmStr) {
    return 0;
  }

  const t = hmStr.split(':');

  return parseInt(t[0], 10) * 3600 + parseInt(t[1], 10) * 60;
};


export const secondsToTimeString = (s) => {
  let h =  Math.floor(s/3600),
      m = Math.ceil((s % 3600) / 60);

  if (h < 10) {
    h = '0' + h;
  } else {
    h = '' + h;
  }

  if (m < 10) {
    m = '0' + m;
  } else {
    m = '' + m;
  }

  return h + ':' + m;
};




// WEBPACK FOOTER //
// ./src/private/admin/utils/scheduler/helpers.js